// var swiper = new Swiper('.main_top_slider', {
//   slidesPerView: 1,
//   spaceBetween: 0,
//   autoplay: true,
//   speed:1000,
//   pagination: {
//       el: '.swiper-pagination',
//   },
  
// });


var swiper = new Swiper('.folks_us_slider', {
  slidesPerView: 2,
  spaceBetween: 30,
  centeredSlides: true,
loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
breakpoints: {
      767: {
      slidesPerView: 1,
      }
  },
});

$(document).ready(function() {
  $( window ).load(function() {
          
    var cookieValue = $.cookie('choosen-accept');
    if (cookieValue != 'yes') {
      $('#revie_popup').trigger('click');
      $('#revie_popup').modal({
        backdrop: 'static'
      });  
    }
    $('#loader-wrapper').hide();
  });	
  
  $( window ).load(function() {        
    $('#load-area').hide();    
  });
  
  $('#website_url').on('click', function(){
    
    $.cookie('choosen-accept', 'yes', {
      expires: 1
    });

    setTimeout(function(){
      window.location.href = "{{ url('') }}"
    }, 1000);
  });

  $('#header').affix({
    offset: {
      top: 100
    }
  });

  $(window).scroll(function() {
    if ($(this).scrollTop()) {
      $('#toTop').fadeIn();
    } else {
      $('#toTop').fadeOut();
    }
  });

  $("#toTop").click(function () {
    $("html, body").animate({scrollTop: 0}, 1000);
  });
  
  var swiper = new Swiper('.main_top_slider', {
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: true,
    speed:1000,
    pagination: {
      el: '.swiper-pagination',
    },
      
  });
  
  $.fn.parallax = function(resistance, mouse) {
    $el = $(this);
    TweenLite.to($el, 0.2, {
      x: -((mouse.clientX - window.innerWidth / 2) / resistance),
      y: -((mouse.clientY - window.innerHeight / 2) / resistance)
    });
  };

  $(document).mousemove(function(e) {
    $(".image-area").parallax(-80, e);
    $(".content_area_slider").parallax(80, e);
    $(".brand-name").parallax(120, e);
    $(".parallax-30").parallax(-60, e);
  });


  // Only String Value .....................
  $(".only-string-values").keypress(function(e){

    var keyCode = e.which;
      /* 
      48-57 - (0-9)Numbers
      65-90 - (A-Z)
      97-122 - (a-z)
      8 - (backspace)
      32 - (space)
      */
      // Not allow special 
      if ( !(  
        (keyCode >= 65 && keyCode <= 90) 
        || (keyCode >= 97 && keyCode <= 122) ) 
        && (keyCode != 8 && keyCode != 32) || (keyCode >= 48 && keyCode <= 57) ) {
        e.preventDefault();
      }
  });


  // Number Key Validation .....................
  $('.number-key-validation').keypress(function(event) {

    var charCode = event.which;

    if ((charCode >= 32) && ((charCode < 48) || (charCode > 57))) {
      event.preventDefault();
    }
  });        

  var ctrlDown = false,
  ctrlKey = 17,
  cmdKey = 91,
  vKey = 86,
  cKey = 67;

  $(document).keydown(function(e) {
    if (e.keyCode == ctrlKey || e.keyCode == cmdKey) ctrlDown = true;
  }).keyup(function(e) {
    if (e.keyCode == ctrlKey || e.keyCode == cmdKey) ctrlDown = false;
  });

  $(".no-copy-paste").keydown(function(e) {
    if (ctrlDown && (e.keyCode == vKey || e.keyCode == cKey)) return false;
  });

  // Document Ctrl + C/V 
  $(document).keydown(function(e) {
    if (ctrlDown && (e.keyCode == cKey)) console.log("Document catch Ctrl+C");
    if (ctrlDown && (e.keyCode == vKey)) console.log("Document catch Ctrl+V");
  });

  //only number with one desible number
  //end
  
});